import { Workshops } from '../model/workshops';
export class WorkshopsBuilder {
    static buildWorkshop(data) {
        const workshop = new Workshops();
        workshop.id = data.id;
        workshop.name = data.name;
        workshop.address = data.address;
        workshop.state = data.state;
        workshop.zip = data.zip;
        workshop.service_email = data.service_email;
        workshop.contact_email = data.contact_email;
        workshop.contact_phone = data.contact_phone;
        workshop.notes = data.notes;
        return workshop;
    }
}
//# sourceMappingURL=workshops-builder.js.map